import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent, useLayoutEffect, useRef } from "react";
import MoodBannerBlockProps from "./MoodBannerProps.interface";
import styles from "./MoodBanner.module.scss";
import VideoViewer from "components/VideoViewer/VideoViewer";
import VideoEmbed from "components/VideoEmbed/VideoEmbed";
import ImageViewer from "components/ImageViewer/ImageViewer";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import { useDispatch } from "react-redux";
import { UpdateMoodBannerHeightAction, UPDATE_MOODBANNERHEIGHT } from "app/umbraco/redux/moodBanner.actions";
import useWindowDimensions from "hooks/useWindowDimensions";
import IconViewer from "components/IconViewer/IconViewer";
import isBrowserContext from "helpers/isBrowserContext";

const MoodBanner: FunctionComponent<MoodBannerBlockProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const bannerRef = useRef<HTMLDivElement>(null);

    const dispatch = useDispatch();

    const imageAspectRatio = getImageAspectRatio(undefined, props?.content?.logo?.umbracoWidth, props?.content?.logo?.umbracoHeight);

    const video = props.content?.video?.[0] && props.content?.video.length > 0 ? props.content.video[0].content : undefined;

    const { width, height } = useWindowDimensions();

    useLayoutEffect(() => {
        if (bannerRef.current) {
            dispatch({ type: UPDATE_MOODBANNERHEIGHT, moodBannerHeight: bannerRef?.current?.offsetHeight } as UpdateMoodBannerHeightAction);
        }
    }, [bannerRef.current, width, height]);

    const onScrollIndicatorClicked = () => {
        if (isBrowserContext()) {
            window.scrollTo({
                left: 0,
                top: bannerRef?.current?.offsetHeight
            });
        }
    };

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses)} style={wrapperStyles} ref={bannerRef}>
            <div className={styles.container}>
                <div className={styles.background_wrapper}>
                    {/* Local Video */}
                    {video && video._contentType === "blockVideoNestedLocal" && video.video?.umbracoFile ? (
                        <VideoViewer className={styles.background} key={props.contentUdi} src={video.video?.umbracoFile} alt={props.content.videoAlternative} soundIcon={true} fullscreenIcon={true} autoplay={true} loop={true} controls={false} />
                    ) : null}

                    {/* Video Embed */}
                    {video && video._contentType === "blockVideoNestedYouTube" && video.videoUrl ? (
                        <VideoEmbed className={styles.background} key={props.contentUdi} src={video.videoUrl} alt={props.content.videoAlternative} soundIcon={true} autoplay={true} loop={true} aspectRatioX={16} aspectRatioY={9} />
                    ) : null}
                </div>

                <div className={styles.content}>
                    <div className={styles.logo_wrapper}>
                        {props.content.logo && props.content.logo.umbracoExtension === "png" ? (
                            <ImageViewer className={styles.logo} src={props.content.logo.umbracoFile.src} extensionType={props.content.logo.umbracoExtension} type="contain" aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} />
                        ) : null}
                        {props.content.logo && props.content.logo.umbracoExtension === "svg" ? (
                            <img className={styles.logo} src={props.content.logo._url} />
                        ) : null}
                    </div>

                    <div className={styles.scroll_indicator} onClick={onScrollIndicatorClicked}>
                        <IconViewer name="chevron-down" aspectRatioX={1} aspectRatioY={1} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MoodBanner;